module.exports = function() {
  return new Worker(__webpack_public_path__ + "a736a89e1b6484757718.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./src/x-loader.worker.js
// module id = tenQ
// module chunks = 1